export const COMPANY_SIZE = [
    {
        value: '1',
        name: '1'
    },
    {
        value: '2-5',
        name: '2-5'
    },
    {
        value: '6-20',
        name: '6-20'
    },
    {
        value: '21-50',
        name: '21-50'
    },
    {
        value: '51-100',
        name: '51-100'
    },
    {
        value: '101-200',
        name: '101-200'
    },
    {
        value: '200+',
        name: '200+'
    }
];
